<template>
  <div class="c-product-info__current">
    <h3
      ref="picks"
      class="c-product-info__current__headingText t-heading-6"
    >
      YOUR {{ bundleSlotCount }} RING BUNDLE
    </h3>
    <transition-group name="fade">
      <div
        v-for="(selection, $index) in displaySelections"
        :key="`${$index}`"
        class="c-product-info__current__selection"
        :class="{
          'c-product-info__current__selection--active': activeIndex === $index,
          'l-flex': true,
          'l-flex__nowrap': true,
          'l-flex--justify-evenly': true,
          'l-flex--align-center': true,
        }"
      >
        <!-- image -->
        <template v-if="selection">
          <button
            v-if="isMobile"
            class="c-product-info__current__remove-button u-center-text"
            @click="handleRemove(selection.bundleType)"
          >
            ×
          </button>
          <img
            class="c-product-info__current__image"
            :src="selection.product | imageThumb"
            :alt="selection.product | imageAlt"
          >
          <!-- slot label -->
          <h4
            :id="`active-${selection.bundleType}-${selection.product.handle}`"
            class="c-product-info__current__title"
            :class="['t-paragraph']"
          >
            {{ selection.product | title }}
            <br>
            Size: {{ activeBundleTypeSize[selection.bundleType] || editSize }}
            <div
              v-if="selection.product.engravingState"
              class="t-heading-13 t-heading-13--x-light"
            >
              <div
                v-for="(prop, index) in selection.product.engravingState.props"
                :key="index"
              >
                {{ prop.key }}: {{ prop.value }}
              </div>
            </div>
          </h4>
          <dropdown
            v-if="isMobile && showEdit($index, selection)"
            :value="activeBundleTypeSize[selection.bundleType]"
            :options="selection.sizes"
            placeholder="Select Size"
            class="c-product-info__current__dropdown"
            @input="handleSelection(selection, $event)"
          />
          <div
            v-if="!isMobile"
            class="c-product-info__current__selection__action"
          >
            <!--<template v-if="showEdit($index, selection)">
              <a
                @click="handleEdit(selection)"
              >
                Edit
              </a>
              <span> | </span>
            </template>-->
            <a
              @click="handleRemove(selection.bundleType)"
            >
              Remove
            </a>
          </div>
        </template>
        <template v-else>
          <div
            class="c-product-info__current__image" 
            style="text-align: center"
          >
            <img
              class="c-product-info__current__image--default"
              src="~@/assets/images/Vector.png"
            >
          </div>
          <h4
            class="c-product-info__current__title"
            :class="['t-paragraph']"
          >
            <img src="~@/assets/images/Rectangle28.png">
            <br>
            <img src="~@/assets/images/Rectangle29.png">
          </h4>
          <btn
            v-if="isMobile"
            class="c-product-info__current__mobile-add-button"
            button-size="x-small"
            type="thin"
            @click="handleEdit(selection, $index)"
          >
            &plus;
          </btn>
        </template>
      </div>
    </transition-group>
  </div>
</template>
<script>
import Btn from '../button/Btn'
import BundleStateMixin from './BundleStateMixin'
import Dropdown from '../dropdown/Dropdown.vue'
import get from 'lodash/get'
import isNumber from 'lodash/isNumber'
import range from 'lodash/range'

export default {
  filters: {
    imageThumb(product) {
      return (
        get(product, 'featuredImage.thumbnailSrc') ||
        get(product, 'featuredImage.src')
      )
    },
    imageAlt(product) {
      return get(product, 'featuredImage.alt')
    },
    title(product) {
      return get(product, 'title', '')
        .replace(/^RAW /, '')
        .replace('Raw 2 gallons per mile Ring -', 'Ring -')
    }
  },
  components: {
    Btn,
    Dropdown,
  },
  mixins: [
    BundleStateMixin
  ],
  data() {
    return { editSize: undefined }
  },
  computed: {
    /**
     * track selected products by slot
     */
    displaySelections() {
      const activeSlots = this.activeBundleTypeProduct
      const activatedTypeSize = this.activeBundleTypeSize
      const sizeOptions = this.sizeOptions
      const slotEntries = Object.entries(activeSlots)
      const bundleSlotCount = this.bundleSlotCount
      let selections = []
      for (let i of range(bundleSlotCount)) {
        const [ bundleType, product ] = slotEntries[i]
        // if there is a product in the slot AND the bundleType has a
        // selected size, show the selection.
        if (product && !!activatedTypeSize[bundleType]) {
          selections.push({
            bundleType,
            product,
            sizes: sizeOptions[bundleType]
          })
        } else {
          selections.push(null)
        }
      }
      return selections
    },
    activeIndex() {
      const displaySelections = this.displaySelections
      return displaySelections.findIndex((v) => v === null)
    }
  },
  methods: {
    showEdit(index) {
      const singleSize = this.singleSize
      return singleSize ? (!!singleSize && (index === 0)) : true
    },
    handleRemove(bundleType) {
      this.$emit('update:size', { bundleType, type: 'size', event: null })
    },
    handleEdit(selection, index) {
      if (selection) {
        let editActiveSelection = false
        for (let { product } of this.activeSelections) {
          if (product.id === selection.product.id) {
            editActiveSelection = true
          }
        }
        if (editActiveSelection) {
          this.editSize = this.activeBundleTypeSize[selection.bundleType]
          this.$emit('update:size', {
            bundleType: selection.bundleType,
            type: 'size',
            event: null
          })
        } else {
          this.editSize = null
          this.$emit('update:bundleProduct', {
            bundleType: selection.bundleType,
            ...selection.product
          })
        }
      } else if (isNumber(index)) {
        this.$emit('update:statusSelect', index)
      }
    },
    handleSelection({ bundleType, product }, event) {
      this.$emit('update:selection', { bundleType, event, product })
    }
  },
}
</script>
<style lang="scss" scoped>
.c-product-info__current {
  &__headingText {
    padding-left: rem(30px);
    margin-top: 20px;
    margin-bottom: 10px;
  }
  &__title {
    margin-bottom: 0;
    flex: 1;
    padding-right: rem(5px);
  }
  &__image {
    width: rem(100px);
    height: rem(100px);
    &--default {
      width: 65%;
      height: 80%;
    }
  }
  &__selection {
    padding: rem(10px) rem(10px) rem(10px) rem(30px);
    &--new {
      margin-left: rem(30px);
    }
    &--active {
      @include themify($themes) {
        background-color: themed('background', 'xx-light');
      }
    }
    &__action {
      @include themify($themes) {
        color: themed('foreground', 'base');
      }
      a {
        border: 0px;
        cursor: pointer;
      }
    }
    &:not(:last-child) {
      border-bottom: 1px solid $light-gray;
    }
    @include respond(phone) {
      padding: rem(10px) 0;
      flex-direction: column;
      align-items: center;
      &:last-child {
        margin-bottom: rem(30px);
      }
    }
  }
  &__dropdown {
    width: rem(120px);
    @include respond(phone) {
      width: rem(194px) !important;
      margin-top: rem(10px);
    }
  }
  &__remove-button {
    @include buttonReset;
    width: rem(30px);
    font-size: rem(30px);
    &:hover {
      cursor: pointer;
    }
    @include respond(phone) {
      align-self: start;
    }
  }
  &__mobile-add-button {
    padding: 0;
    width: rem(52px);
    height: rem(52px);
    @include respond(phone) {
      width: rem(194px);
    }
  }
}
</style>
